import { ISearchContentItem, ISearchSubTreeContentItem, IVariable, IVariablesSearchResult, IVariablesTree, IVariableValuesSearchResult } from "../../interfaces/variable.interface";
import { IPresetReduced } from "../../interfaces/presets.interface";

const ActionTypes = {
  GET_VARIABLES_TREE: '[Variables] Get Variables Tree',
  GET_VARIABLES_TREE_SUCCESS: '[Variables] Get Variables Tree Success',
  GET_VARIABLES_TREE_FAIL: '[Variables] Get Variables Tree Fail',

  GET_VARIABLE_INFO: '[Variables] Get Variable Info',
  GET_VARIABLE_INFO_SUCCESS: '[Variables] Get Variable Info Success',
  GET_VARIABLE_INFO_FAIL: '[Variables] Get Variable Info Fail',

  CLEAR_VARIABLE_INFO: '[Variables] Clear Variable Info',

  GET_VARIABLES_PRESET_LIST: '[Variables] Get Variables Preset List',
  GET_VARIABLES_PRESET_LIST_SUCCESS: '[Variables] Get Variables Preset List Success',
  GET_VARIABLES_PRESET_LIST_FAIL: '[Variables] Get Variables Preset List Fail',

  GET_VARIABLES_PRESET: '[Variables] Get Variables Preset',
  GET_VARIABLES_PRESET_SUCCESS: '[Variables] Get Variables Preset Success',
  GET_VARIABLES_PRESET_FAIL: '[Variables] Get Variables Preset Fail',

  SEARCH_VARIABLE: '[Variables] Search Variable',
  SEARCH_VARIABLE_SUCCESS: '[Variables] Search Variable Success',
  SEARCH_VARIABLE_FAIL: '[Variables] Search Variable Fail',

  CLEAR_SEARCHED_VARIABLE: '[Variables] Clear Searched Variable',

  SEARCH_SUB_TREE_VARIABLE: '[Variables] Search Sub Tree Variable',
  SEARCH_SUB_TREE_VARIABLE_SUCCESS: '[Variables] Search Sub Tree Variable Success',
  SEARCH_SUB_TREE_VARIABLE_FAIL: '[Variables] Search Sub Tree Variable Fail',

  CLEAR_SEARCHED_SUB_TREE_VARIABLE: '[Variables] Clear Searched Sub Tree Variable',

  SEARCH_VARIABLE_VALUE: '[Variables] Search Variable Value',
  SEARCH_VARIABLE_VALUE_SUCCESS: '[Variables] Search Variable Value Success',
  SEARCH_VARIABLE_VALUE_FAIL: '[Variables] Search Variable Value Fail',

  CLEAR_VARIABLE_VALUE_SEARCH_RESULTS: '[Variables] Clear Variable Value Search Results',
}

export class GetVariablesTree {
  static type = ActionTypes.GET_VARIABLES_TREE;
}

export class GetVariablesTreeSuccess {
  static type = ActionTypes.GET_VARIABLES_TREE_SUCCESS;

  constructor(public payload: IVariablesTree) {}
}

export class GetVariablesTreeFail {
  static type = ActionTypes.GET_VARIABLES_TREE_FAIL;

  constructor(public payload: { status: number; message: string }) {}
}

export class GetVariableInfo {
  static type = ActionTypes.GET_VARIABLE_INFO;

  constructor(public payload: string) {}
}

export class GetVariableInfoSuccess {
  static type = ActionTypes.GET_VARIABLE_INFO_SUCCESS;

  constructor(public payload: any) {}
}

export class GetVariableInfoFail {
  static type = ActionTypes.GET_VARIABLE_INFO_FAIL;
}

export class ClearVariableInfo {
  static type = ActionTypes.CLEAR_VARIABLE_INFO;
}

export class GetVariablesPresetList {
  static type = ActionTypes.GET_VARIABLES_PRESET_LIST;
}

export class GetVariablesPresetListSuccess {
  static type = ActionTypes.GET_VARIABLES_PRESET_LIST_SUCCESS;

  constructor(public payload: {'content': IPresetReduced[]}) {}
}

export class GetVariablesPresetListFail {
  static type = ActionTypes.GET_VARIABLES_PRESET_LIST_FAIL;
}

export class GetVariablesPreset {
  static type = ActionTypes.GET_VARIABLES_PRESET;

  constructor(public payload: string) {}
}

export class GetVariablesPresetSuccess {
  static type = ActionTypes.GET_VARIABLES_PRESET_SUCCESS;

  constructor(public payload: {'content': string[]}) {}
}

export class GetVariablesPresetFail {
  static type = ActionTypes.GET_VARIABLES_PRESET_FAIL;
}



export class SearchVariable {
  static type = ActionTypes.SEARCH_VARIABLE;

  constructor(public payload: string) {}
}

export class ClearSearchedVariable {
  static type = ActionTypes.CLEAR_SEARCHED_VARIABLE
}

export class SearchVariableSuccess {
  static type = ActionTypes.SEARCH_VARIABLE_SUCCESS;

  constructor(public payload: {
    content: ISearchContentItem[],
    hits_returned: number,
    warning: string | null
  }){}
}

export class SearchVariableFail {
  static type = ActionTypes.SEARCH_VARIABLE_FAIL;
}

export class SearchSubTreeVariable {
  static type = ActionTypes.SEARCH_SUB_TREE_VARIABLE;

  constructor(public payload: {
    filterTreeName: string,
    query: string
  }) {}
}

export class SearchSubTreeVariableSuccess {
  static type = ActionTypes.SEARCH_SUB_TREE_VARIABLE_SUCCESS;

  constructor(public payload: {
    content: ISearchSubTreeContentItem[],
    hits_returned: number,
    warning: string | null
  }){}
}

export class SearchSubTreeVariableFail {
  static type = ActionTypes.SEARCH_SUB_TREE_VARIABLE_FAIL;
}

export class ClearSearchedSubTreeVariable {
  static type = ActionTypes.CLEAR_SEARCHED_SUB_TREE_VARIABLE;
}

export class SearchVariableValue {
  static type = ActionTypes.SEARCH_VARIABLE_VALUE;

  constructor(public payload: {variableName: string, input: string}) {}
}

export class SearchVariableValueSuccess {
  static type = ActionTypes.SEARCH_VARIABLE_VALUE_SUCCESS;

  constructor(public payload: IVariableValuesSearchResult) {}
}

export class SearchVariableValueFail {
  static type = ActionTypes.SEARCH_VARIABLE_VALUE_FAIL;
}

export class ClearVariableValueSearchResults {
  static type = ActionTypes.CLEAR_VARIABLE_VALUE_SEARCH_RESULTS;
}

